import(/* webpackMode: "eager" */ "/home/runner/work/RecipeManager/RecipeManager/apps/web/src/app/page.tsx");
